import classNames from "classnames";
import { t } from "i18next";
import { FC, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useGetOrganizationsQuery } from "~@/graphql/codegen/generated";

const steps = [
  {
    title: t("onboarding.steps.verification"),
    pathname: "/welcome/verification",
  },
  { title: t("onboarding.steps.password"), pathname: "/welcome/password" },
];

const stepsAlternate = [
  {
    title: t("onboarding.steps.pricing"),
    pathname: "/welcome/pricing",
  },
  {
    title: t("onboarding.steps.signing"),
    pathname: "/welcome/signing",
  },
  {
    title: t("onboarding.steps.payment-method"),
    pathname: "/welcome/payment-method",
  },
];

const OnboardingSteps: FC = () => {
  const location = useLocation();

  const { data: organizationsData } = useGetOrganizationsQuery();

  const currentOrganization = useMemo(() => {
    return organizationsData?.getOrganizations?.current;
  }, [organizationsData]);

  const isTrial = useMemo(() => {
    return currentOrganization?.isTrial;
  }, [currentOrganization]);

  const currentSteps = useMemo(() => {
    if (isTrial) {
      return [...steps];
    } else {
      return [...stepsAlternate];
    }
  }, [isTrial]);

  return (
    <ul className="onboarding-steps">
      {currentSteps.map((step, index) => {
        return (
          <li
            key={index}
            className={classNames("onboarding-steps__item", {
              "onboarding-steps__item--is-active": location.pathname.includes(
                step.pathname
              ),
            })}
          >
            <div className="icon-text">
              <span className="icon onboarding-steps__icon">{index + 1}</span>
              <span>{step.title}</span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default OnboardingSteps;
